export function currentCustomerName(pool, getCustomer) {
    const customer = getCustomer(pool.customerId);

    return customer ? customer.name : pool.customerName;
}

export function withCurrentCustomerName(pool, getCustomer) {
    return {...pool, customerName: currentCustomerName(pool, getCustomer)};
}
